// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: true,
//   baseURL: 'https://www.sehyog.co.uk/services/',
//   // frontBaseURL: 'https://staging.sehyog.co.uk/',
//   //baseURL: 'http://localhost:8008/',
//   frontBaseURL: 'http://localhost:4300/',
//   liveGoogleCaptcha: '6LcvoUgUAAAAAJJbhcXvLn3KgG-pyULLusaU4mL1',
//   vendorDashboardURL: 'https://onlineexam.sehyog.co.uk/CBT2393/UserLogin.aspx?ClientID=239300', // changing as per vendor asked on 10-08-24 https://onlinetestforum.com/ECAS/UserLogin.aspx
// };

// export const environment = {
//   production: false,
//   //baseURL: 'http://localhost:8008/',
//   baseURL: 'https://www.sehyog.co.uk/services/', // Production service URL
//   //frontBaseURL: 'https://staging.sehyog.co.uk/',
//   //baseURL: 'https://staging.sehyog.co.uk/services/',
//   frontBaseURL: 'http://localhost:4300/', // Keep frontend local
//   liveGoogleCaptcha: '6LcvoUgUAAAAAJJbhcXvLn3KgG-pyULLusaU4mL1',
//   vendorDashboardURL: 'https://onlineexam.sehyog.co.uk/CBT2393/UserLogin.aspx?ClientID=239300',
// };


export const environment = {
  production: true,
  baseURL: 'https://www.sehyog.co.uk/services/',
  frontBaseURL: 'https://www.sehyog.co.uk/',
  //baseURL: 'https://staging.sehyog.co.uk/services/',
  // frontBaseURL: 'https://staging.sehyog.co.uk/',
  liveGoogleCaptcha: '6LfP6KcUAAAAAAUlIn5zohaCJBSYir2ZPhoRrXz3',
  vendorDashboardURL: 'https://onlineexam.sehyog.co.uk/CBT2393/UserLogin.aspx?ClientID=239300', // changing as per vendor asked on 10-08-24 https://onlinetestforum.com/ECAS/UserLogin.aspx
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
